<template>
  <td :class="action">{{ amountInCurrency }}</td>
</template>

<script>
  import utils from '../../../../utils';
  import { mapGetters } from 'vuex';

  export default {
    name: "TableBlueAmountLabel",
    props: ['action', 'amount'],
    computed: {
      ...mapGetters(['currency']),
      amountInCurrency() {
        const amount = utils.convertSystemToCurrency(this.amount, this.currency);
        switch (this.action) {
          case 'CREATE':
            return amount;
          case 'DEPOSIT':
            return amount;
          case 'WITHDRAW':
            return `-${amount}`;
          case 'REMOVE':
            return `-${amount}`;
          default:
            throw new Error(`no such action:${this.action}`);
        }
      },
    },
  }
</script>

<style scoped>
  td {
    text-align: right !important;
  }

  .CREATE {
    color: #093;
  }

  .DEPOSIT {
    color: #093;
  }

  .WITHDRAW {
    color: #f08080;
  }

  .REMOVE {
    color: #f08080;
  }
</style>
